<template>
  <div class="out">
    <div class="electricity">
      <div class='normed-header'>
        <Header>
          <div v-if="message.checkFlag != 1">
            <span @click="onClickCheck" class="delete">立即查验</span>
            <div style="display: inline-block; width: 8px;"></div>
            <span @click="onClickRight" class="delete">修改</span>
            <div style="display: inline-block; width: 8px;"></div>
            <span @click="onClickRightDel" v-if="message.reimbursementFlag !== 2" class="delete">删除</span>
          </div>
          <div v-else>
            <span @click="onClickRightDel" v-if="message.reimbursementFlag !== 2" class="delete">删除</span>
          </div>
        </Header>
        <div>
          <!-- 国家税务局通用定额发票 -->
          <div class="sellerName" v-if="message.invoiceType === '201'">火车票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '202'">飞机票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '01'">增值税专用发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '11'">增值税普通发票（卷式）</div>
          <div class="sellerName" v-else-if="message.invoiceType === '04'">增值税普通发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '207'">出租车</div>
          <div class="sellerName" v-else-if="message.invoiceType === '10'">增值税普通电子发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '08'">增值税电子专用发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '90'">数电普通发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '09'">数电专用发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '85'">数电纸质专用发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '86'">数电纸质普通发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '200'">定额发票</div>
        </div>
        <div class='back-color'>
          <div></div>
        </div>
      </div>
      <div class='img'>
        <div @click='handleShowImg'>
          <img :src='getOcrUrl(message.ocrUrl)' alt='' />
        </div>
        <div>
          <div class='huisuiyunfont'>
            <span>{{ '\ue630' }}</span
            >拍照识别
            </div>
            <div class='huisuiyunfont'>
              <span>{{ '\ue632' }}</span
              >{{ message.createTime ? message.createTime.split(' ')[0] : '' }}
            </div>
            <div class='huisuiyunfont check'>
              <div v-if="message.checkFlag == 0" class="no-check">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">暂未查验</div>
              </div>
              <div v-if="message.checkFlag == 1">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">查验成功</div>
              </div>
              <div v-if="message.checkFlag == 2" class="fail-check">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">查验失败</div>
              </div>
              <div v-if="message.reimbursementFlag !== 0" :class="[getColor(message.reimbursementFlag)]">
                <div v-if="message.reimbursementFlag === 1" class="icon">{{'\ue66e'}}</div>
                <div v-if="message.reimbursementFlag === 2" class="icon">{{'\ue66d'}}</div>
                <div v-if="message.reimbursementFlag === 3" class="icon">{{'\ue66c'}}</div>
                <div class="check-text" v-if="message.reimbursementFlag === 1">待审批</div>
                <div class="check-text" v-if="message.reimbursementFlag === 2">已完成</div>
                <div class="check-text" v-if="message.reimbursementFlag === 3">已驳回</div>
              </div>
            </div>
          </div>
        </div>
      <div class="content">
        <div class="cardType">
        <!-- <CardType :item='message' :time="this.time" :tag='tag'></CardType> -->
        <div v-if='message.exceptionInfo !="0" && message.exceptionInfo !=null' class="abnormal">
          <div class="no">异</div>
          <div v-if="message.exceptionInfo =='1'">异常提醒 : 发票检验未通过！</div>
          <div v-else-if="message.exceptionInfo == '2'">异常提醒 : 不符合预设校验规则！</div>
          <div v-else>{{ message.exceptionInfo }}</div>
        </div>
      </div>
      <div class="collapseItem">
        <div class="title">销方名称</div>
        <van-collapse v-model="activeNames2">
          <van-collapse-item name="1">
            <slot slot="title" name="title" v-if="message.sellerName">
              <span class="name">{{message.sellerName ? message.sellerName : '无'}}</span>
            </slot>
            <div class="account">
              <div class="top top-height">
                纳税人识别号
              </div>
              <div class="bottom">
                {{message.sellerTaxNo ? message.sellerTaxNo : '无'}}
              </div>
            </div>
            <div class="account center">
              <div class="top">
                地址及电话
              </div>
              <div class="bottom">
                {{message.sellerAddressTel ? message.sellerAddressTel : '无'}}
              </div>
            </div>
            <div class="account footer">
              <div class="top">
                开户银行及账号
              </div>
              <div class="bottom">
                {{message.sellerBank ? message.sellerBank :'无'}}
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="collapseItem">
        <div class="title">购方名称</div>
        <van-collapse v-model="activeNames">
          <van-collapse-item name="1">
            <slot slot="title" name="title" v-if="message.purchaserName">
              <span class="name">{{message.purchaserName ? message.purchaserName : '无'}}</span>
            </slot>
            <div class="account">
              <div class="top top-height">
                纳税人识别号
              </div>
              <div class="bottom">
                {{message.purchaserTaxNo ? message.purchaserTaxNo : '无'}}
              </div>
            </div>
            <div class="account center">
              <div class="top">
                地址及电话
              </div>
              <div class="bottom">
                {{message.purchaserAddressTel ? message.purchaserAddressTel : '无'}}
              </div>
            </div>
            <div class="account footer">
              <div class="top">
                开户银行及账号
              </div>
              <div class="bottom">
                {{message.purchaserBank ? message.purchaserBank : '无'}}
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="my-collapse">
        <MyCollapse :card="{
          Content1:message.amountWithTax,
          Content2:``,
          Content3:message.amount,
          Content4:(message.amountWithTax - message.amount).toFixed(2)
        }" :title="cardTitle" :money="true"></MyCollapse>
      </div>
      <div class="must-invoice">
        <MustInvoice :card='{
          Content:message.invoiceCode,
          Content1:message.invoiceNo,
          Content2:message.drewDate,
          Content3:message.checkCode
        }' :title='title2'></MustInvoice>
      </div>
      <div class="shop-detail">
        <div class="shop-detail-title">
          <div>商品明细 <span>{{'('+this.number+')'}}</span></div>
          <div>向左滑动查看更多</div>
          <!-- <div>></div> -->
        </div>
        <div class="more">
          <div class="more-title">
            <div class="more-left">
              <div class="more-left-title">项目名称</div>
              <div class="more-names" v-for="(item,index) in message.detailList" :key="index">
                {{item.goodsName}}
              </div>
              <div class="sum">
                合计
              </div>
            </div>
            <div class="more-right">
              <div class="scroll-wrp">
                <section>
                  <div>金额</div>
                  <div>税率</div>
                  <div>税额</div>
                </section>
                <div class="moer-content list-bottom" v-for="(item,index) in message.detailList" :key="index">
                  <div>{{setMonths(item.amount)}}</div>
                  <div>{{item.taxRate + '%'}}</div>
                  <div>{{setMonths(item.taxAmount)}}</div>
                </div>
                <div class="moer-content sum-row">
                  <div>{{setMonths(sumAmount)}}</div>
                  <div>{{''}}</div>
                  <div>{{setMonths(sumTaxAmount)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="remark">
        <van-cell-group>
          <van-cell title="备注" :label="message.remark ? message.remark : '无'" />
        </van-cell-group>
      </div>
      </div>
      <div class="lookElectornic">
        <LookElectornic :imgShow.sync="imgShow" :urlImg='message.ocrUrl'></LookElectornic>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar, Icon, CollapseItem, Collapse, Dialog, Notify, Cell, CellGroup, Toast } from 'vant'
import { personalInvoicesRequest, officialAccountRequest } from '@services'
import LookElectornic from '@/components/LookElectronic'
import MyCollapse from '@/components/MyCollapse'
import Header from '@/components/Header/index.vue'
import MustInvoice from '@/components/MustInvoice'
import { BIG_THUMBNAIL_CONFIG } from '@/assets/config'
export default {
  data () {
    return {
      id: '',
      exceptionInfo: '',
      time: '',
      tag: '',
      imgShow: false,
      activeNames: [''],
      activeNames2: [''],
      sumAmount: 0,
      sumTaxAmount: 0,
      number: 0,
      cardTitle: {
        title: '含税总价',
        title2: '合计金额',
        title3: '合计税额'
      },
      message: {},
      title2: {
        title: '发票代码',
        title1: '发票号码',
        title2: '开票日期',
        title3: '校验码'
      }
    }
  },
  async mounted () {
    this.id = this.$route.query.id
    this.exceptionInfo = this.$route.query.exceptionInfo
    this.time = this.$route.query.time
    this.source = this.$route.query.source
    const invoiceCode = this.$route.query.code
    const invoiceNo = this.$route.query.no
    // 此处判断是否是异常
    // 0 正常 1异常 （增票）
    if (Number(this.source) === 0) {
      // const data = await personalInvoicesRequest.personalInvoices.getCard({ id: this.id })
      const data = await personalInvoicesRequest.personalInvoices.getInvoiceInfo({ invoiceCode, invoiceNo })
      if (data.success) {
        if (data.result) {
          this.message = data.result
          this.tag = this.tag
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    } else {
      const data = await personalInvoicesRequest.personalInvoices.getAbnormalInvoiceInfo({ invoiceCode, invoiceNo })
      if (data.success) {
        if (data.result) {
          this.message = data.result
          this.tag = this.tag
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  watch: {
    message (v) {
      if (v.detailList) {
        v.detailList.map((item) => {
          this.sumAmount += Number(item.amount)
          this.sumTaxAmount += Number(item.taxAmount)
        })
        if (v.detailList.length > 0) {
          this.number = v.detailList.length
        } else {
          this.number = 0
        }
      }
    }
  },
  methods: {
    async onClickRightDel () {
      Dialog.confirm({
        title: '提示',
        message: '是否要删除此发票信息!'
      }).then(async () => {
        const result = await personalInvoicesRequest.personalInvoices.deleteCard({
          invoiceNo: this.message.invoiceNo,
          invoiceCode: this.message.invoiceCode,
          invoiceSource: this.message.invoiceSource
        })
        if (result.success) {
          Notify({ type: 'success', message: '操作成功' })
          this.$router.go(-1)
        } else {
          Notify({ type: 'warning', message: result.message })
        }
      }).catch(() => {
        return false
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    handleShowImg () {
      if (this.message.ocrUrl.indexOf('.pdf') !== -1 || this.message.ocrUrl.indexOf('.ofd') !== -1) {
        return
      }
      this.imgShow = true
    },
    async onClickRight () {
      this.$store.commit('invoice/changeInfoInvoice', this.message)
      this.$router.push('/newInvoice/editInvoice')
    },
    async onClickCheck () {
      Toast.loading({
        message: '查验中...',
        duration: 0,
        forbidClick: true
      })
      const res = await officialAccountRequest.weChat.againInspection({ invoiceList: [{ ...this.message }], reCheck: '1' })
      if (res.success) {
        Notify({ type: 'success', message: '操作成功!' })
        Toast.clear({
          clearAll: true
        })
        this.$router.push('/ticket/center/index')
      } else {
        Notify({ type: 'danger', message: res.message })
      }
      Toast.clear({
        clearAll: true
      })
    }
  },
  computed: {
    setMonths () {
      return function (money) {
        return parseInt(money) === money ? money + '.00' : Number(money).toFixed(2)
      }
    },
    getOcrUrl () {
      return (url) => {
        if (url) {
          let index = url.indexOf('http')
          let newUrl = url
          if (index === -1) {
            newUrl = 'http://huisuiyun.oss-cn-shanghai.aliyuncs.com/' + url
          }
          newUrl = BIG_THUMBNAIL_CONFIG(newUrl)
          console.log(newUrl)
          return newUrl
        }
      }
    },
    getColor () {
      return (i) => {
        switch (i) {
          case 0:
            return ''
          case 1:
            return 'padding'
          case 2:
            return ''
          case 3:
            return 'back'
          default:
            break
        }
      }
    }
  },
  components: {
    MyCollapse,
    MustInvoice,
    LookElectornic,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Dialog.name]: Dialog,
    [Notify.name]: Notify,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    Header
  }
}
</script>
<style scoped lang="less">
.out {
  overflow: scroll;
  height: 100%;
  position: relative;
  background-color: #f5f5f5;
}
.electricity {
  // padding: 0px 24px;
  padding-bottom: 150px;
  background: transparent;
  // background-color: #f5f5f5;
  .shop-detail{
    width: 702px;
    margin-bottom: 16px;
    border-radius: 8px;
    background: #fff;
    padding: 0px 24px;
    box-sizing: border-box;
    .shop-detail-title{
      display: flex;
      font-size: 24px;
      height: 80px;
      line-height: 80px;
      border-bottom: 0.5Px solid #ECEEF1;
      color: #9EA9B9;
      div:nth-of-type(1){
        width: 60%;
        color: #3E4966;
        font-size: 30px;
        font-weight: 900;
        span{
          display: inline-block;
          vertical-align: top;
          margin-top: -3px;
        }
      }
      div:nth-of-type(2){
        width: 40%;
        text-align: right;
      }
    }
    .more-title{
      display: flex;
      font-size: 28px;
      // height: 96px;
      line-height: 85px;
      color: #3E4966;
      overflow-x: scroll;
      border-bottom: 0.5Px solid #ECEEF1;
      .more-left{
        width:57%;
        .more-left-title{
          border-bottom: 0.5Px solid #ECEEF1;
          color: #3E4966;
          font-size: 28px;
        }
        .more-names{
          color: #3E4966;
          border-bottom: 0.5Px solid #ECEEF1;
          font-size: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .sum{
          color: #3378FF;
          font-size: 28px;
          font-weight: 600;
        }
      }
      .list-bottom{
        border-bottom: 0.5Px solid #ECEEF1;
      }
      .more-right{
        width: 43%;
        color: #3E4966;
        overflow-x: scroll;
        .scroll-wrp{
          width: 450px;
          section{
            text-align: right;
            border-bottom: #ECEEF1 0.5Px solid;
            display: grid;
            grid-template-columns: 40% 28% 32%;
          }
          .moer-content{
            text-align: right;
            display: grid;
            grid-template-columns: 40% 28% 32%;
          }
          .sum-row{
            font-size: 28px;
            color: #3378FF;
          }
        }
      }
    }
  }
  .remark{
    margin-bottom: 30px;
    border-radius: 8px;
    /deep/.van-cell{
      padding-left: 12px;
      padding-top: 12px;
      padding-right: 12px;
      border-radius: 8px;
    }
    /deep/.van-cell-group{
      border-radius: 4px;
    }
    /deep/.van-cell__title{
      span{
        font-size: 16px;
        font-weight: bold;
        display: inline-block;
        color: #3E4966;
        margin-bottom: 8px;
      }
    }
    /deep/.van-cell__label{
      color:#3E4966;
      border-top: 0.5Px solid #ECEEF1;
      padding-top: 10px;
    }
  }
  /deep/.van-cell:not(:last-child)::after{
    border-bottom: 1Px solid #ECEEF1;
    left: 0px;
  }
  /deep/.van-cell__right-icon{
    font-size: 14px !important;
    color: #9EA9B9 !important;
    font-weight: bold !important;
  }
  .cardType {
    margin-bottom: 16px;
  }
  /deep/.van-nav-bar {
    background-color: #f5f5f5;
    height: 100px;
    .van-nav-bar__text {
      color: #3e4966;
      font-size: 28px;
    }
    .GoBack {
      color: #3e4966;
    }
    .delete{
      font-size: 28px;
      color: #3e4966;
      margin-right: 10px;
    }
  }
  .collapseItem {
    padding: 28px 24px 0px 24px;
    margin-bottom: 16px;
    box-sizing: border-box;
    width: 702px;
    background: #fff;
    border-radius: 8px;
    .top-height{
      margin-top: 18px;
    }
    .title {
      font-size: 24px;
      color: #9ea9b9;
    }
    /deep/.van-cell {
      // position: none !important;
      padding: 12px 0px;
    }
    /deep/.van-collapse-item__content {
      padding: 0;
    }
    /deep/.van-icon{
      font-size: 28px;
      font-weight: bold;
    }
    .name {
      font-size: 30px;
      color: #3e4966;
      font-weight: 700;
    }
    /deep/[class*="van-hairline"]::after {
      border: none;
      border-bottom: 1Px solid #ebedf0;
    }
    .account {
      .top{
        color: #9EA9B9;
        font-size: 24px;
      }
      .bottom {
        font-size: 28px;
        color: #3e4966;
      }
    }
    .center {
      padding: 48px 0px;
    }
    .footer {
      padding-bottom: 16px;
    }
  }
}
.normed-header{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgba(51, 120, 255, 1);
  position: fixed;
  width: 100%;
  z-index: 10;
  .sellerName{
    padding: 0px 0px 120px;
    padding-left: 16px;
    box-sizing: border-box;
    font-size: 48px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .back-color{
    div{
      border-radius: 16px 16px 0 0;
      height: 100px;
      background: rgba(245, 245, 245, 1);
    }
  }
}
.content{
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 220px;
}
.abnormal{
  display: flex;
  width: 100%;
  height: 64px;
  font-size: 26px;
  border-radius: 8px;
  line-height: 64px;
  align-items: center;
  color: rgba(255, 111, 92, 1);
  padding: 0 16px;
  box-sizing: border-box;
  background: rgba(255, 111, 92, 0.03);
  .no{
    width: 40px;
    height: 40px;
    background: rgba(255, 111, 92, 0.08) !important;
    border-radius: 8px;
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    line-height: 40px;
    margin-right: 12px;
    color: rgba(255, 111, 92, 1);
  }
}
.check{
  box-sizing: border-box;
  padding: 16px 0 0 16px;
  display: flex;
  .check-text{
    font-weight: bold;
  }
  .icon{
    margin: 2px 4px 0px;
  }
}
.check>div:first-of-type {
  padding: 2px 12px;
  background: rgba(14, 169, 117, 0.12);
  color: rgba(14, 169, 117, 1);
  display: flex;
  align-items: center;
  text-align: center;
  height: 40px;
  margin-right: 8px;
  div{
    margin-bottom: 0 !important;
  }
}
.check>div:last-of-type {
  display: flex;
  align-items: center;
  padding: 2px 12px;
  background: rgba(14, 169, 117, 0.12);
  color: rgba(14, 169, 117, 1);
  text-align: center;
  div{
    margin-bottom: 0 !important;
  }
}
.padding {
  color: rgba(255, 167, 77, 1) !important;
  background: rgba(255, 167, 77, 0.12) !important;
}
.back {
  color: rgba(255, 111, 92, 1) !important;
  background: rgba(255, 111, 92, 0.12) !important;
}
  .img{
    padding: 24px;
    box-sizing: border-box;
    width: 718px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    margin-bottom: 16px;
    position: fixed;
    z-index: 11;
    top: 180px;
    width: 708px;
    left: 50%;
    transform: translateX(-50%);
  }
  .img>div:first-of-type{
    width: 284px;
    height: 176px;
    border-radius: 8px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  .img>div:last-of-type{
    font-size: 26px;
    color: rgba(122, 134, 153, 0.8);
    flex-grow: 1;
    div{
      margin-bottom: 16px;
    }
    span{
      padding: 0 16px;
    }
  }
  .fail-check{
    background-color: rgba(241, 89, 69, 0.12) !important;
    color: #f15945 !important;
  }
  .no-check{
    background: rgba(255, 153, 51, 0.1) !important;
    color: #ff9933 !important;
  }
</style>
